module.exports = __webpack_public_path__ + "img/play.28eb26dd.svg";